<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import ArtworkCanvas from "./ArtworkCanvas.vue";
import ArtworkSurfacePosition from "./ArtworkSurfacePosition.vue";
import ArtworkSize from "./ArtworkSize.vue";

const store = useStore();
const artworkExists = computed(() => store.getters["artwork/artworkExists"]);
</script>

<template>
  <div class="artwork">
    <div class="artwork__title">Design location & size</div>

    <div class="artwork__canvas">
      <ArtworkCanvas />
    </div>

    <div class="artwork__controls" :class="{ 'artwork__controls--disabled': !artworkExists }">
      <ArtworkSurfacePosition />
      <ArtworkSize />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/pod/settings";

.artwork {
  @include with-desktop {
    text-align: center;
    padding: 20px 8px;
    border-radius: 8px;
    border: 1px solid $pod-gray-modern-200;
    background: white;
    box-shadow: $pod-card-shadow;
  }

  &__title {
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: 500;

    @include with-desktop {
      text-align: center;
    }
  }

  &__canvas {
    width: 100vw;
    margin: 0 (-$indent-mobile-constructor);

    @include with-desktop {
      width: auto;
      display: flex;
      justify-content: center;
      margin: 0;
    }
  }

  &__controls {
    display: grid;
    grid-row-gap: 18px;
    margin-top: 13px;

    &--disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
}
</style>
